<template>
  <div>
    <van-tabs
      v-model="active"
      color="#2B71FE"
      line-width="80"
      title-active-color="#2B71FE"
      title-inactive-color="#707070"
      @change="changeTitle"
    >
      <van-tab title="全部打印机" name="0"></van-tab>
      <van-tab title="已激活打印机" name="1"></van-tab>
      <van-tab title="待维修打印机" name="2"></van-tab>
    </van-tabs>
    <div class="list" ref="listout">
      <van-list @load="onLoad" v-model="loadFinish" :finished="finished">
        <div class="item" v-for="(item, index) in list" :key="index">
          <div class="item-title">打印机编码：{{ item.name }}</div>
          <div
            class="item-content"
            :style="
              item.expire_status == 2
                ? { background: '#A0A0A0' }
                : { background: 'linear-gradient(-40deg, #44d0c9,#6faee2, #2b71fe)' }
            "
          >
            <p>
              <span> 品牌： {{ item.brand_name }}</span>
              <span style="float: right"> 型号：{{ item.model }} </span>
            </p>
            <p>激活时间：{{ item.activate_time }}</p>
            <p>
              <span> 维保到期日：{{ item.maintenance_expire_time }} </span>
              <span style="float: right">
                激活用户：{{ item.tenant_name }}
              </span>
            </p>
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
import { getPrinterList, getTenantList } from '@/api/printer'
export default {
  data() {
    return {
      active: 0,
      list: [],
      loadFinish: false,
      finished: false, //加载完成
      page: 1,
      pageSize: 10,
      tenantList: [],
    }
  },
  created() {},
  computed: {},
  methods: {
    onLoad() {
      this.loadFinish = true
      this.getList()
    },
    changeTitle() {
      this.list = []
      this.page = 1
      this.loadFinish = false
      this.finished = false
      this.$refs.listout.scrollTop = 0
      this.onLoad()
    },
    getList() {
      let params = {
        status: this.active == 1 ? 1 : null,
        expire_status: this.active == 2 ? 2 : null,
        type:2,
        page: this.page,
        per_page: 10,
      }
      getPrinterList(params).then((res) => {
        this.page++
        if (res && res.data && res.data.length > 0) {
          this.list.push(...res.data)
          if (res.data.length < 10) {
            this.finished = true
          }
          setTimeout(() => {
            this.loadFinish = false
          }, 200)
        }else{
          this.finished = true
        }
      })
    },
  },
}
</script>
<style lang="less" scoped>
.list {
  margin-left: 65px;
  margin-bottom: 50px;
  .item {
    &-title {
      font-size: 42px;
      color: #313131;
      margin-top: 64px;
      margin-bottom: 36px;
      font-weight: 400;
    }
    &-content {
      width: 994px;
      height: 257px;
      box-shadow: 0px 0px 13px 2px rgba(88, 87, 87, 0.1);
      border-radius: 5px;
      color: #fdfcfc;
      font-size: 36px;
      padding: 38px;
      p:nth-child(2) {
        margin-top: 8px;
      }
      p:nth-child(3) {
        margin-top: 8px;
      }
    }
  }
}
</style>
